import { useUserStore } from '@/store/modules/user'

function authPermission(permission: string) {
    const store = useUserStore()
    const all_permission = '*:*:*'
    const permissions = store.permissions || []

    if (permission) {
        return permissions.some((v) => v === all_permission || v === permission)
    }
    return false
}

function authRole(role: string) {
    const store = useUserStore()
    const super_admin = 'admin'
    const roles = store.roles || []

    if (role) {
        return roles.some((v) => v === super_admin || v === role)
    }
    return false
}

export default {
    hasPermi(permission: string) {
        return authPermission(permission)
    },
    hasPermiOr(permissions: string[]) {
        return permissions.some((item) => authPermission(item))
    },
    hasPermiAnd(permissions: string[]) {
        return permissions.every((item) => authPermission(item))
    },
    hasRole(role: string) {
        return authRole(role)
    },
    hasRoleOr(roles: string[]) {
        return roles.some((item) => authRole(item))
    },
    hasRoleAnd(roles: string[]) {
        return roles.every((item) => authRole(item))
    }
}
